export default "__VITE_ASSET__C3oOTOIT__"